import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const selectionToolbarPluginKey: PluginKey = new PluginKey('selectionToolbarPluginKey');
